import { render } from "./icon-angle-left.vue?vue&type=template&id=eabf948c"
import script from "./icon-angle-left.vue?vue&type=script&lang=js"
export * from "./icon-angle-left.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__